<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <br/>
    <b-button variant="primary" v-if="loading" disabled>
      <b-spinner small></b-spinner>
      Cargando...
    </b-button>

    <div class="col-md-12"></div>
    <p
        v-show="listaPtis.length === 0"
        class="mginTop15 boldBlue size22"
    >
      No se encontraron ptis para el paciente.
    </p>

    <div v-show="listaPtis.length !== 0" class="presupuestos">
      <div
          v-for="item in listaPtis"
          :key="item.idPti"
          :value="item.nombreClinica"
      >
        <div class="accordion divPresupuesto" role="tablist">
          <b-button
              :class="item.visible ? null : 'collapsed'"
              :aria-expanded="item.visible ? 'true' : 'false'"
              @click="traerTratamientos(item)"
              id="text-button"
              variant="primary"
          >
            <b-icon icon="caret-up-fill" v-if="item.visible"></b-icon>
            <b-icon icon="caret-down-fill" v-else></b-icon>
            {{ item.nombreClinica }} - {{ item.fecha }}
          </b-button>
          <b-collapse v-model="item.visible" visible accordion="my-accordion" role="tabpanel">
            <div class="noAlTope">
              <b-button variant="primary" v-if="loadingOpciones" disabled>
                <b-spinner small></b-spinner>
                Cargando...
              </b-button>

              <div class="mb-4">
                <b-badge v-if="opcion === 0"
                    variant="success"
                    class="trtPadecimiento"
                >No ha aceptado ninguna opción del PTI</b-badge>
                <b-badge v-else
                    variant="success"
                    class="trtPadecimiento"
                >{{tituloOpcion[opcion] + ' opción aceptada'}}</b-badge>
              </div>



              <div class="text-left">
                <b-table-simple
                    hover
                    small
                    style="font-size: 14px; margin-bottom: 0rem !important"
                >
                  <b-thead class="columnas">
                    <b-tr>
                      <b-th colspan="4"></b-th>
                      <b-th class="text-center" colspan="2">
                        Total precio PTI sin descuento
                      </b-th>
                      <b-th class="text-center" colspan="3">
                        Total de precio PTI aceptado
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr>
                      <b-td colspan="4"></b-td>
                      <b-td class="text-center" colspan="2">
                        {{ totalTratamiento | moneda }}
                      </b-td>
                      <b-td class="text-center" colspan="3">
                        {{ totalSeleccionado | moneda }}
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <b-thead class="columnas">
                    <b-tr>
                      <b-th class="text-center">OD</b-th>
                      <b-th>Diagnóstico</b-th>
                      <b-th>Tratamiento</b-th>
                      <b-th class="text-center">Costo original</b-th>
                      <b-th class="text-center">No. Sesion</b-th>
                      <b-th class="text-center">Descuento</b-th>
                      <b-th class="text-center">Precio final</b-th>
                      <b-th class="text-center">Tipo de padecimiento</b-th>
                      <b-th class="text-center">Acción</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-if="seleccionPlanTratamientos.length > 0">
                    <b-tr
                        v-for="(padecimiento, index) in seleccionPlanTratamientos"
                        :key="index"
                    >
                      <b-td class="text-center">
                        {{ padecimiento.numeroDiente }}
                      </b-td>
                      <b-td>{{ padecimiento.diagnostico }}</b-td>

                      <b-td>
                        <b-table-simple
                            small
                            style="font-size: 14px; margin-bottom: 0rem !important"
                        >
                          <b-tbody>
                            <b-tr
                                v-for="(trts, indice) in padecimiento.tratamientos"
                                :key="indice"
                            >
                              <b-td>{{ trts.nombreTratamiento }}</b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-td>

                      <b-td class="text-center">
                        <b-table-simple
                            small
                            style="font-size: 14px; margin-bottom: 0rem !important"
                        >
                          <b-tbody>
                            <b-tr
                                class="text-left"
                                v-for="(trts, indice) in padecimiento.tratamientos"
                                :key="indice"
                            >
                              <b-td>{{ trts.total | moneda }}</b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-td>

                      <b-td class="text-center">
                        <b-table-simple
                            small
                            style="font-size: 14px; margin-bottom: 0rem !important"
                        >
                          <b-tbody>
                            <b-tr
                                v-for="(trts, indice) in padecimiento.tratamientos"
                                :key="indice"
                            >
                              <b-td>{{ trts.noSesion }}</b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-td>

                      <b-td class="text-center">
                        <b-table-simple
                            small
                            style="font-size: 14px; margin-bottom: 0rem !important"
                        >
                          <b-tbody>
                            <b-tr
                                v-for="(trts, indice) in padecimiento.tratamientos"
                                :key="indice"
                            >
                              <b-td>{{ trts.descuento }}%</b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-td>

                      <b-td class="text-center">
                        <b-table-simple
                            small
                            style="font-size: 14px; margin-bottom: 0rem !important"
                        >
                          <b-tbody>
                            <b-tr
                                v-for="(trts, indice) in padecimiento.tratamientos"
                                :key="indice"
                            >
                              <b-td>{{ trts.costoUnitario | moneda }}</b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-td>

                      <b-td class="text-center">
                        <b-table-simple
                            small
                            style="font-size: 14px; margin-bottom: 0rem !important"
                        >
                          <b-tbody>
                            <b-tr
                                v-for="(trts, indice) in padecimiento.tratamientos"
                                :key="indice"
                            >
                              <b-td
                                  v-if="
                              trts.nombreTipoPadecimiento === 'INDISPENSABLE'
                            "
                              >
                                <strong>Indispensable</strong>
                              </b-td>
                              <b-td
                                  style="color: red"
                                  v-else-if="
                              trts.nombreTipoPadecimiento === 'INFECCIOSO'
                            "
                              >
                                <strong>Infeccioso</strong>
                              </b-td>
                              <b-td
                                  style="color: orange"
                                  v-else-if="
                              trts.nombreTipoPadecimiento === 'FUNCIONAL'
                            "
                              >
                                <strong>Funcional</strong>
                              </b-td>
                              <b-td style="color: green" v-else>
                                <strong>Estéticos</strong>
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-td>

                      <b-td>
                        <b-table-simple
                            small
                            style="font-size: 14px; margin-bottom: 0rem !important"
                        >
                          <b-tbody>
                            <b-tr
                                v-for="(
                            trts, indiceTratamiento
                          ) in padecimiento.tratamientos"
                                :key="indiceTratamiento"
                            >
                              <b-td>
                                <div
                                    v-if="
                                trts.nombreTipoPadecimiento !== 'INDISPENSABLE'
                              "
                                >
                                  <div
                                      style="
                                  background-color: #007bff;
                                  border-radius: 4px;
                                  color: white;
                                  width: 70px;
                                "
                                      v-if="trts.aceptada"
                                  >
                                    Aceptado
                                  </div>
                                  <div
                                      style="
                                  background-color: #dc3545;
                                  border-radius: 4px;
                                  color: white;
                                  width: 70px;
                                "
                                      v-else
                                  >
                                    Denegado
                                  </div>
                                </div>
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <b-tbody v-else>
                    <b-tr>
                      <b-td colspan="9"><b-alert style="text-align: center" show variant="warning">Cancelaron los tramientos o el recibo.</b-alert></b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>

              <!-- <b-tabs content-class="mt-3" v-model="tabIndex"> -->

<!--                <div v-for="opcion in opcionesPTI" :key="opcion.numeroOpcion">
                  <b-tab v-bind:title="tituloOpcion[opcion.numeroOpcion] + ' opción'">
                    <template #title >
                      <font-awesome-icon v-if="(opcion.opcionAceptada && !opcion.opcionPagada) || (opcion.opcionPagada && !opcion.opcionAceptada)" icon="check-circle" style="color: green"/>
                      <font-awesome-icon v-if="!opcion.opcionAceptada && !opcion.opcionPagada" icon="times-circle" style="color: #ffc107"/>
                      {{tituloOpcion[opcion.numeroOpcion] + ' opción'}}
                    </template>
                    <p class="boldBlue size18">
                      <b-badge
                          variant="success"
                          class="trtPadecimiento"
                          v-if="opcion.opcionAceptada && !opcion.opcionPagada"
                      >Opción aceptada</b-badge>
                      <b-badge
                          variant="success"
                          class="trtPadecimiento"
                          v-if="opcion.opcionPagada && !opcion.opcionAceptada"
                      >Opción aceptada y pagada</b-badge>
                      <b-badge
                          variant="warning"
                          class="trtPadecimiento"
                          v-if="!opcion.opcionAceptada && !opcion.opcionPagada"
                      >Opción no aceptada</b-badge>
                    </p>

                    <div>
                      <b-table-simple hover small>
                        <b-thead class="columnas">
                          <b-tr>
                            <b-th colspan="3"></b-th>
                            <b-th class="text-center" colspan="3">
                              Total precio PTI sin descuento
                            </b-th>
                            <b-th class="text-center" colspan="2">
                              Total Descuento
                            </b-th>
                            <b-th class="text-center" colspan="3"
                            >Total de precio PTI aceptado
                            </b-th
                            >
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td colspan="3"></b-td>
                            <b-td class="text-center" colspan="3">
                              {{ (opcion.totalTratamiento + opcion.sumaComplentos) | moneda }}
                            </b-td>
                            <b-td class="text-center" colspan="2">
                              {{ opcion.totalPromocion | moneda }}
                            </b-td>
                            <b-td class="text-center" colspan="3">
                              {{ (opcion.totalSeleccionado + opcion.sumaComplentos) | moneda }}
                            </b-td>
                          </b-tr>
                        </b-tbody>

                        <b-thead class="columnas">
                          <b-tr>
                            <b-th class="text-center">OD</b-th>
                            <b-th>Diagnóstico</b-th>
                            <b-th>Tratamiento</b-th>
                            <b-th class="text-right">Precio</b-th>
                            <b-th class="text-center">No. Sesiones a realizar</b-th>
                            <b-th class="text-center">No. Sesiones a pagar</b-th>
                            <b-th class="text-center">Cantidad</b-th>
                            <b-th class="text-center">Descuento</b-th>
                            <b-th class="text-right">Precio total</b-th>
                            <b-th class="text-center">Tipo de padecimiento</b-th>
                            <b-th>Estatus</b-th>
                          </b-tr>
                        </b-thead>

                        <b-tbody>
                          <b-tr
                              v-for="(
                          padecimiento, index
                        ) in opcion.opcionTratamientos.tratamientos"
                              :key="index"
                          >
                            <b-td class="text-center">
                              {{ padecimiento.numeroDiente }}
                            </b-td>
                            <b-td>{{ padecimiento.diagnostico }}</b-td>

                            <b-td>
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indice
                                ) in padecimiento.tratamientos"
                                      :key="indice"
                                  >
                                    <b-td>{{ trts.nombreTratamiento }}</b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>

                            <b-td class="text-right">
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indice
                                ) in padecimiento.tratamientos"
                                      :key="indice"
                                  >
                                    <b-td>
                                      {{ trts.costoUnitario | moneda }}
                                    </b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>

                            <b-td class="text-center">
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indice
                                ) in padecimiento.tratamientos"
                                      :key="indice"
                                  >
                                    <b-td>{{ trts.numeroSesiones }}</b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>

                            <b-td class="text-center">
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indice
                                ) in padecimiento.tratamientos"
                                      :key="indice"
                                  >
                                    <b-td>{{ trts.numeroSesionesPagar }}</b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>

                            <b-td class="text-center">
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indice
                                ) in padecimiento.tratamientos"
                                      :key="indice"
                                  >
                                    <b-td>{{ trts.cantidad }}</b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>

                            <b-td class="text-center">
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indice
                                ) in padecimiento.tratamientos"
                                      :key="indice"
                                  >
                                    <b-td>{{ trts.descuento }}%</b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>

                            <b-td class="text-right">
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indice
                                ) in padecimiento.tratamientos"
                                      :key="indice"
                                  >
                                    <b-td>
                                      {{ trts.costoSesion | moneda }}
                                    </b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>

                            <b-td class="text-center">
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indice
                                ) in padecimiento.tratamientos"
                                      :key="indice"
                                  >
                                    <b-td
                                        v-if="
                                    trts.tipoPadecimiento === 'INDISPENSABLE'
                                  "
                                    >
                                      <strong>Indispensable</strong>
                                    </b-td>
                                    <b-td
                                        style="color: red"
                                        v-else-if="
                                    trts.tipoPadecimiento === 'INFECCIOSO'
                                  "
                                    >
                                      <strong>Infeccioso</strong>
                                    </b-td>
                                    <b-td
                                        style="color: orange"
                                        v-else-if="
                                    trts.tipoPadecimiento === 'FUNCIONAL'
                                  "
                                    >
                                      <strong>Funcional</strong>
                                    </b-td>
                                    <b-td style="color: green" v-else>
                                      <strong>Estéticos</strong>
                                    </b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>

                            <b-td>
                              <b-table-simple small>
                                <b-tbody>
                                  <b-tr
                                      v-for="(
                                  trts, indiceTratamiento
                                ) in padecimiento.tratamientos"
                                      :key="indiceTratamiento"
                                  >
                                    <b-td>
                                      <div
                                          v-if="
                                      trts.tipoPadecimiento !== 'INDISPENSABLE'
                                    "
                                      >
                                        <b-badge
                                            size="sm"
                                            variant="primary"
                                            class="trtPadecimiento"
                                            v-if="trts.aceptar"
                                        >Aceptado</b-badge
                                        >
                                        <b-badge
                                            size="sm"
                                            variant="danger"
                                            class="trtPadecimiento"
                                            v-if="!trts.aceptar"
                                        >Denegado</b-badge
                                        >
                                      </div>
                                    </b-td>
                                  </b-tr>
                                </b-tbody>
                              </b-table-simple>
                            </b-td>
                          </b-tr>
                        </b-tbody>


                      </b-table-simple>
                    </div>


                  </b-tab>
                </div>-->
              <!-- </b-tabs> -->
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
    <br/>
    <br/>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";

export default {
  name: "PresupuestoHistoricoV4",
  components: {},
  props: {
    idPaciente: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    totalTratamiento: null,
    totalSeleccionado:null,
    opcion: null,
    seleccionPlanTratamientos: [],
    planSeleccionado: null,
    idSolicitud: null,
    selectMode: "multi",
    selected: [],
    listaPtis: [],
    opcionesPTI: [],
    loading: true,
    loadingOpciones: false,
    banderaBtn: false,
    tituloOpcion: ["", "Primera", "Segunda", "Tercera"],
    titulos: [
      {
        key: "etapa",
        label: "Etp",
        sortable: true,
      },
      {
        key: "noDiente",
        label: "OD",
        sortable: true,
      },
      {
        key: "numSesiones",
        label: "Cantidad",
        sortable: true,
      },
      {
        key: "tratamientoNombre",
        label: "Tratamiento",
        sortable: true,
      },
      {
        key: "precio",
        label: "Precio unitario",
        sortable: true,
      },
      {
        key: "descuento",
        label: "Descuento unitario",
        sortable: true,
      },
      {
        key: "ahorro",
        label: "Ahorro",
        sortable: true,
      },
      {
        key: "precioTotal",
        label: "Precio total unitario",
        sortable: true,
      },
      {
        key: "tratamientoProgramado",
        label: "Programado",
        sortable: true,
      },
      {
        key: "tratamientoActivo",
        label: "Tratamiento Activo",
        sortable: true,
      },
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.getPtis();
  },
  methods: {
    getPtis() {
      const parametros = {idPaciente: this.idPaciente}
      this.$http
          .post(
              this.$api +
              "diagnostico/obtener/pti/paciente", parametros
          )
          .then((response) => {
            var datos = JSON.parse(JSON.stringify(response.data.data));
            if (Array.isArray(datos)) {
              this.listaPtis = datos;
              this.listaPtis = _.chain(this.listaPtis)
                  .groupBy("idPti")
                  .map((value, key) => ({
                    idPti: key,
                    idClinica: value[0]["idClinica"],
                    nombreClinica: value[0]["clinicaNombre"],
                    fecha: moment(value[0]["fechaAlta"]).utc().format("DD/MM/YYYY"),
                    visible: false,
                  }))
                  .value();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.errorMensaje(err);
          })
          .finally(() => {
            this.banderaBtn = false;
            this.loading = false;
          });
    },
    traerOpciones(item) {
      item.visible = !item.visible
      if (item.visible) {
        const urlOpciones =
            this.$api +
            "diagnostico/obtener/OpcionesTratamientos/Pti?pti=" +
            item.idPti +
            "&idClinica=" + item.idClinica;

        let listaOpciones = [];
        this.loadingOpciones = true;
        this.$http
            .get(urlOpciones)
            .then((response) => {
              if (response.data.data) {
                this.loadingOpciones = false;
                response.data.data.forEach((opciones) => {
                  let datosOpciones = {};
                  //guardamos el numerop de la opciones
                  datosOpciones["numeroOpcion"] = opciones.opcion;

                  datosOpciones["totalPromocion"] = opciones.montoDescuento;

                  datosOpciones["opcionAceptada"] = opciones.opcionAceptada;

                  datosOpciones["opcionPagada"] = opciones.opcionPagada;

                  // borramos el numero de la opcion
                  delete opciones.opcion;

                  //agregamos los tratamientos  y agregamos una varibale para opcion
                  datosOpciones["opcionTratamientos"] = opciones;

                  let total = 0;
                  let totalSeleccionado = 0;

                  opciones.tratamientos.forEach((diagnostico) => {
                    diagnostico.tratamientos.forEach((trt) => {
                      let costoSuma = trt.costoUnitario * trt.cantidad;
                      total += costoSuma;
                      if (trt.aceptar) {
                        totalSeleccionado += trt.costoSesion;
                      }
                    });
                  });

                  datosOpciones["totalTratamiento"] = total;
                  datosOpciones["totalSeleccionado"] = totalSeleccionado;

                  if (opciones.complementos !== undefined) {
                    datosOpciones["seleccionadoComplemento"] = opciones.complementos;
                    if (datosOpciones["seleccionadoComplemento"] !== undefined) {
                      datosOpciones["seleccionadoComplemento"].forEach((it) => {
                        it.editar = false;
                      });
                    }

                    if (
                        datosOpciones["seleccionadoComplemento"] !== undefined &&
                        datosOpciones["seleccionadoComplemento"] !== null
                    ) {
                      datosOpciones["complementosTomaHerramientas"] = JSON.parse(
                          JSON.stringify(
                              datosOpciones["seleccionadoComplemento"].filter(
                                  (st) =>
                                      st.tratamientoIndispensable !== undefined &&
                                      st.tratamientoIndispensable !== null &&
                                      st.tratamientoIndispensable === true
                              )
                          )
                      );
                    }
                    datosOpciones["sumaComplentos"] = 0;
                    datosOpciones["seleccionadoComplemento"].map((com) => {
                      datosOpciones["sumaComplentos"] =
                          datosOpciones["sumaComplentos"] + com.cantidad * com.costoSesion;
                    });
                    datosOpciones["seleccionadoComplementoAnterior"] = JSON.parse(
                        JSON.stringify(datosOpciones["seleccionadoComplemento"])
                    );
                  }

                  listaOpciones.push(datosOpciones);
                });

                this.opcionesPTI = listaOpciones;
              }
            })
            .catch((error) => {
              this.loadingOpciones = false;
              this.showErrorMsg(error);
            });
      }

    },
    traerTratamientos(item) {
      item.visible = !item.visible
      const parametros = {
        idPti: item.idPti,
        replica: false
      }
      if (item.visible) {
        const url =
            this.$api +
            "diagnostico/obtener/tratamientos/contratados";

        this.loadingOpciones = true;
        this.$http
            .post(url, parametros)
            .then((response) => {
              if (response.data.data) {
                this.loadingOpciones = false;
                this.seleccionPlanTratamientos = response.data.data.tratamientos;
                this.opcion = response.data.data.opcion;
                let total = 0;
                let totalSeleccionado = 0;
                response.data.data.tratamientos.forEach((diagnostico) => {
                  diagnostico.tratamientos.forEach((trt) => {
                    total += trt.total;
                    if (trt.aceptada) {
                      totalSeleccionado += trt.costoUnitario;
                    }
                  });
                });

                this.totalTratamiento = total;
                this.totalSeleccionado = totalSeleccionado;
              }
            })
            .catch((error) => {
              this.loadingOpciones = false;
              this.showErrorMsg(error);
            });
      }
    },
  },
}
</script>

<style scoped>
.alignLeft {
  width: 100%;
  text-align: left;
}

.presupuestos {
  min-height: 200px;
}

.divPresupuesto {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 10px;
}

#text-button {
  text-align: left;
}

.trtPadecimiento {
  padding: 10px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: lighter;
}

.badgeCss {
  display: flex;
  justify-content: flex-end;
}

.txtDoctor {
  color: black;
  text-align: left;
  margin-bottom: -10px;
}

.boldTxt {
  font-weight: bolder;
}

.flxButton {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
}

.btnEstilo {
  width: 250px;
}
</style>
